import { useState } from 'react';

import { useMakeStripeCheckoutMutation } from '@interfaces/graphql-typings';
import { STRIPE_URL } from '@buyside/util/payment';
import { PaymentPlanValues } from '@interfaces/payment/plans';
import { useScript } from '@buyside/util/hooks/script';
import { ENV_VARS, verifyEnvVar } from '@env/usage';
import isLocalStorageNameSupported from '@buyside/util/isLocalStorageNameSupported';

const useMakeStripeCheckout = (
  plan: PaymentPlanValues
): {
  onSubmit: (email?: string) => void;
  loading: boolean;
  error: boolean;
} => {
  const [error, setError] = useState(false);

  const isScriptLoaded = useScript(STRIPE_URL);

  const [makeStripeCheckout, { loading }] = useMakeStripeCheckoutMutation();

  const onSubmit = async (email?: string): Promise<void> => {
    setError(false);

    try {
      const res = await makeStripeCheckout({
        variables: { plan, currentUrl: window.location.href, email }
      });

      if (isLocalStorageNameSupported()) window.localStorage.setItem('stripePlan', plan);

      const sessionId = res.data?.makeStripeCheckout?.sessionId;

      if (sessionId) {
        const stripe = window.Stripe(verifyEnvVar(ENV_VARS.STRIPE_PUBLIC_KEY));
        await stripe.redirectToCheckout({ sessionId });
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    }
  };

  return { onSubmit, loading: Boolean(!isScriptLoaded || loading), error };
};

export default useMakeStripeCheckout;
